import { gql } from '@apollo/client';

export const UPDATE_INVENTORY_REQUEST = gql`
  mutation UpdateInventoryRequest(
    $request_id: String!,
    $date: String!,
    $items: [InventoryItemInput!]!
  ) {
    updateInventoryRequest(
      request_id: $request_id,
      date: $date,
      items: $items
    ) {
      status
      message
      inventory_requests {
        inv_id
        date
        status
      }
    }
  }
`;
